import React from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';
import { getMediaTypeFromUrl } from '../../../utils/helpers';

const BannerPreview = ({ 
  imageUrl, 
  caption, 
  title,
  specifications = {}
}) => {
  const { isRTL } = useLanguage();
  const aspectRatio = specifications?.aspect_ratio || '3:1';
  
  // Get aspect ratio class
  const getAspectClass = () => {
    switch (aspectRatio) {
      case '3:1': return 'aspect-[3/1]';
      case '4:1': return 'aspect-[4/1]';
      case '2:1': return 'aspect-[2/1]';
      case '16:9': return 'aspect-video';
      default: return 'aspect-[3/1]';
    }
  };

  return (
    <div className="w-full max-w-[800px] mx-auto">
      <div className="bg-white rounded-lg border border-gray-200 overflow-hidden shadow-lg">
        {/* Website Header Bar */}
        <div className="bg-gray-50 border-b border-gray-200 px-4 py-2 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-red-500"></div>
            <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
            <div className="w-3 h-3 rounded-full bg-green-500"></div>
          </div>
          <div className="flex-1 mx-4 bg-white border border-gray-300 rounded px-3 py-1 text-xs text-gray-600">
            {isRTL ? 'https://example.com' : 'https://example.com'}
          </div>
          <div className="text-xs text-gray-500">🔒</div>
        </div>

        {/* Banner Container */}
        <div className={`relative bg-gray-100 ${getAspectClass()}`}>
          {imageUrl ? (
            getMediaTypeFromUrl(imageUrl) === 'video' ? (
              <video
                src={imageUrl}
                className="w-full h-full object-cover"
                controls
                muted
                playsInline
              />
            ) : (
              <img 
                src={imageUrl} 
                alt={title || 'Banner'} 
                className="w-full h-full object-cover"
              />
            )
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-gray-100 to-gray-200">
              <div className="text-center p-4">
                <span className="text-5xl block mb-2">🏷️</span>
                <p className="text-gray-500 text-sm">
                  {isRTL ? 'معاينة البانر' : 'Banner Preview'}
                </p>
                <p className="text-gray-400 text-xs mt-1">{aspectRatio}</p>
              </div>
            </div>
          )}
          
          {/* Overlay Content (if caption/title provided) */}
          {(title || caption) && (
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent flex items-end">
              <div className="p-6 w-full text-white">
                {title && (
                  <h2 className="text-2xl md:text-3xl font-bold mb-2">{title}</h2>
                )}
                {caption && (
                  <p className="text-sm md:text-base opacity-90 line-clamp-2">{caption}</p>
                )}
                {/* CTA Button */}
                <button className="mt-4 px-6 py-2 bg-white text-gray-900 rounded-lg font-semibold hover:bg-gray-100 transition-colors">
                  {isRTL ? 'احصل عليه الآن' : 'Get Started'}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      <p className="text-center text-xs text-gray-500 mt-2">
        {isRTL ? 'معاينة البانر' : 'Website Banner Preview'}
      </p>
    </div>
  );
};

export default BannerPreview;

